import { memo } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import Tooltip from "@mui/material/Tooltip";
import Skeleton from "@mui/material/Skeleton";
import { BooleanSwitchValue } from "consts/general";
import { when } from "util/support";
import When from "ui/support/When";
import { Collection } from "ui/support/Resource";
import Loader from "ui/molecules/Loader";
import type { ECommerceSettingsStatusCassetteProps } from "./types";

const ECommerceSettingsStatusCassette = ({
    title,
    settings
}: ECommerceSettingsStatusCassetteProps) => (
    <Card
        elevation={0}
        sx={{
            display: 'grid',
            gap: 3,
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: 'divider',
            maxWidth: 400,
            p: 2
        }}
    >
        <When
            if={Boolean(title)}
            then={(
                <Typography
                    sx={{
                        color: theme => theme.palette.text.disabled
                    }}
                >
                    {title}
                </Typography>
            )}
        />
        <Collection
            collection={when(
                settings.length,
                settings,
                [
                    {
                        name: <Skeleton height={50} />,
                        isLoading: true,
                        value: BooleanSwitchValue.Off
                    }
                ]
            )}
            renderResource={({ isLoading, name, value, tooltip }) => (
                <Box
                    sx={{
                        display: 'grid',
                        gap: 2,
                        gridTemplateColumns: '1fr auto'
                    }}
                >
                    <Box
                        sx={{
                            color: theme => when(
                                title,
                                theme.palette.text.secondary,
                                theme.palette.text.disabled
                            ),
                        }}
                    >
                        {name}
                    </Box>
                    <Loader
                        isLoading={isLoading}
                    >
                        <Tooltip
                            arrow
                            placement='top'
                            {...tooltip}
                        >
                            <Box>
                                <When
                                    if={value}
                                    then={(
                                        <Button
                                            startIcon={<TaskAltIcon />}
                                            variant='text'
                                            size='small'
                                            color='success'
                                            sx={{
                                                pointerEvents: 'none'
                                            }}
                                        >
                                            Active
                                        </Button>
                                    )}
                                    else={(
                                        <Button
                                            variant='text'
                                            size='small'
                                            disabled
                                        >
                                            Inactive
                                        </Button>
                                    )}
                                />
                            </Box>
                        </Tooltip>
                    </Loader>
                </Box>
            )}
        />
    </Card>
);

export default memo(ECommerceSettingsStatusCassette);
